import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class LoginValidator {

    public submitted: boolean = false;
    public loginForm: UntypedFormGroup;
    public formBuilder: UntypedFormBuilder

    createForm(formBuilder: UntypedFormBuilder) {
        this.loginForm = formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
        });
    }

    isValid() {
        this.submitted = true;
        return this.loginForm.invalid ? false : true;
    }

    get f() { return this.loginForm.controls; }
}